<template>
  <div id="">

    <HeaderSection ref="header"></HeaderSection>

    <div class="container-fluid mt-4 mb-5">
      <!--keep-alive>
        <router-view />
      </keep-alive-->
      <router-view v-slot="{ Component }" >
        <keep-alive>
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </keep-alive>
      </router-view>
    </div>

    <FooterSection ref="footer"></FooterSection>

  </div>



</template>

<script>

import HeaderSection from "@/components/sections/HeaderSection.vue";
import FooterSection from "@/components/sections/FooterSection.vue";
import { useHead } from '@vueuse/head';
import {computed, watch} from "vue";
import {useI18n} from "vue-i18n";
//import {useRoute} from "vue-router";


export default {
  name: 'App',
  components: {
    HeaderSection,
    FooterSection
  },

  setup() {
    const { locale } = useI18n();  // Aquí accedes al idioma actual
    //const route = useRoute();  // Obtienes la ruta actual

    // Computed para obtener la meta info basada en el idioma actual
    const getMetaInfo = computed(() => {
      let title, description, keywords;

      if (locale.value === 'ca') {
        title = "Aprèn - Portal de l'activitat docent del professorat de la UPC";
        description = "Aprèn és el portal que facilita l’accés als continguts que elabora el professorat de la Universitat Politècnica de Catalunya (UPC) com a eina de suport a la seva activitat docent.";
        keywords = "apren,upc,producció,docent,docència,universitat,professorat";
      } else if (locale.value === 'es') {
        title = "Aprèn - Portal de la activitat docente del profesorado de la UPC";
        description = "Aprèn es el portal que facilita el acceso a los contenidos que elabora el profesorado de la Universitat Politècnica de Catalunya (UPC) como herramienta de apoyo a su actividad docente.";
        keywords = "apren,upc,producción,docente,docencia,universidad,profesorado";
      } else {
        title = "Aprèn - Website of the learning activity by UPC teachers";
        description = "Aprèn is a portal that provides access to the teaching support materials developed by the teaching staff of the Universitat Politècnica de Catalunya (UPC).";
        keywords = "apren,upc,production,learning,university,teacher";
      }

      return {
        title,
        description,
        keywords,
        htmlAttrs: {
          lang: locale.value
        }
      };
    });

    // Función para actualizar las meta tags cuando cambien el idioma o la ruta
    const updateMetaTags = () => {
      const metaInfo = getMetaInfo.value;
      useHead({
        title: metaInfo.title,
        meta: [
          { name: 'description', content: metaInfo.description },
          { name: 'keywords', content: metaInfo.keywords },
          { name: 'author', content: 'Universitat Politècnica de Catalunya (UPC). Iniciativa Digital Politècnica (IDP)' },
          { name: 'author', content: 'Universitat Politècnica de Catalunya (UPC). Servei de Biblioteques, Publicacions i Arxius (SBPA)' }
        ],
        link: [
          /*{ rel: 'alternate', hreflang: 'ca', href: `/ca${route.path.substr(3)}` },
          { rel: 'alternate', hreflang: 'es', href: `/es${route.path.substr(3)}` },
          { rel: 'alternate', hreflang: 'en', href: `/en${route.path.substr(3)}` },
          { rel: 'canonical', href: route.path }*/
        ]
      });
    };

    // Observa cambios en el idioma y la ruta para actualizar las meta tags
    watch([locale], updateMetaTags, { immediate: true });

    return {
    }

  }
}
</script>


<style>

</style>
